// components/Hero.jsx
import React from "react";
import heroBg from "../assets/images/hero-bg.jpg";
import "./Hero.css";

const Hero = () => {
  return (
    <div className="hero-wrapper">
      <div
        className="hero-bg"
        style={{ backgroundImage: `url(${heroBg})` }}
      ></div>
      <div className="hero-overlay"></div>

      <section className="container hero-section">
        <div className="hero-content">
          <h2 className="fw-bold display-4 hero-title">
            Crafting Future-Ready, <br />{" "}
            <span className="orange-txt">Creative & Modern</span>
            <br />
            <span className="blu-txt">Digital Solutions</span>
          </h2>

          <p className="mt-4 fs-5 col-lg-6 hero-text">
            Grow your brand with result-driven digital solutions. TECKPIK blends
            strategy, design, development, and marketing to help you stand out
            online and win more customers worldwide.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Hero;
